import styled from "styled-components";

export const Terms = styled.div`
  text-align: left;

  h4,
  li {
    color: gray;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    line-height: 1.4;
  }

  h4 {
    font-weight: 700;
    margin-bottom: 9px;
  }

  ul {
    margin-left: 14px;
  }

  li {
    font-weight: 400;
    list-style: disc;
    margin-bottom: 6px;
  }
`;
